import {format as formatDate, FORMAT_LONG_ALL} from '@/util/dateUtils';

export function formatApiTime(value) {
    if (!value) return '';
    return formatDate(value, FORMAT_LONG_ALL);
}
